import { Logos } from "@/libraries/design/patterns/logos/src/logos";

import { UniformLogo, flattenLogoProps } from "../../../contenttypes/logo";

export interface UniformLogosProps {
    title?: string;
    logos: UniformLogo[];
}

// eslint-disable-next-line @typescript-eslint/no-explicit-any
const UniformLogos = (intakeProps: any) => {
    const { title, logos }: UniformLogosProps = flattenLogoProps(intakeProps);
    return <Logos title={title} logos={logos} />;
};

export default UniformLogos;
